import { createContext, useContext } from 'react';

import type { TargetSkillProficiencySummary } from 'bundles/page-config-common/types/enterprise';

export type EnterpriseSkillSetsContextType = {
  skillsets: TargetSkillProficiencySummary[];
  hasError: boolean;
  skillsetsLoading: boolean;
};

const EnterpriseSkillSetsContext = createContext<EnterpriseSkillSetsContextType>({
  skillsets: [],
  hasError: false,
  skillsetsLoading: false,
});

/**
 * @description This hook is used to access the program's skillsets
 */
export const useEnterpriseSkillsets = () => useContext(EnterpriseSkillSetsContext);

export default EnterpriseSkillSetsContext;
